import { useQuery } from "@tanstack/react-query";

import { bucketAPI } from "@api/bucket";
import { processRequest } from "@api/config";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useVerificationTextQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_VERIFICATION_TEXT],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_VERIFICATION_TEXT,
				request: () => bucketAPI.getVerificationTextAsync(),
			});

			return data;
		},
	});

export const useBigWishContentQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.BIG_WISH_CONTENT],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_BIG_WISH_CONTENT,
				request: () => bucketAPI.getBigWishContentAsync(),
			});

			return data;
		},
	});

export const useIntegrationContentQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.INTEGRATION_CONTENT],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_INTEGRATION_CONTENT,
				request: () => bucketAPI.getIntegrationContentAsync(),
			});

			return data;
		},
	});

export const useDefaultTipMenuItemsQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.DEFAULT_TIP_MENU_ITEMS],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_DEFAULT_TIP_MENU_ITEMS,
				request: () => bucketAPI.getDefaultTipMenuItemsAsync(),
			});

			return data;
		},
	});

export const useToysHowToGuideQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.TOYS_HOW_TO_GUIDE],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_TOYS_HOW_TO_GUIDE,
				request: () => bucketAPI.getToysHowToGuideAsync(),
			});

			return data;
		},
	});
